import React from 'react';
import { useTranslation } from 'utils/i18n';
import { StaticPageShell, ComingSoon } from 'feSharedIndex';
import translations from './translations';
import './Events.css';

/**
 * Events Component
 * Displays company events and upcoming activities.
 * Uses StaticPageShell + ComingSoon from fe-shared; theme from config.
 */
const Events = () => {
  const { language } = useTranslation();
  const pageTranslations = translations[language] || translations.en;

  const t = (key, defaultValue = '') => {
    const value = key.split('.').reduce((obj, k) => obj?.[k], pageTranslations);
    return value || defaultValue || key;
  };

  return (
    <StaticPageShell
      title={t('title', 'Events')}
      lead={t('description', 'Stay up to date with our upcoming events, webinars, and conferences')}
      contentClassName="events-page-content"
    >
      <ComingSoon
        title={t('placeholder.title', 'Events Coming Soon')}
        message={t('placeholder.description', 'We are currently planning exciting events, webinars, and conferences. Check back soon for updates!')}
      />
    </StaticPageShell>
  );
};

export default Events;


